import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import * as moment from 'moment-business-days';
import { find } from 'lodash';
import {
  Icon,
  IconButton,
  Notification,
  BookingPayment,
  BookingPrices,
  HeadingSection,
  RouteWrapper,
  Section,
  BookingSidebar,
  Box,
} from '../../components';
import EXPIRATIONS from '../../data/expirations';
import { getBooking } from '../../redux/actions/bookings';

interface Props {
  vehicleTypes: any;
  match: any;
  dispatch: Function;
}

interface State {
  id: number;
  companyId: number;
  isReady: boolean;
  error: string | boolean;
  isPaid: boolean;
  isLoading: boolean;
  booking?: any;
  vehicleType?: any;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      id: Number(this.props.match.params.id),
      companyId: Number(this.props.match.params.company_id),
      isReady: false,
      isLoading: true,
      error: false,
      isPaid: false,
    };
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  /**
   * Retrieve all bookings and vehicle types from API
   */
  async componentDidMount() {
    const bookingResponse = await this.props.dispatch(
      getBooking(this.state.id),
    );
    if (bookingResponse.error) {
      this.setState({ error: bookingResponse.error });
      return;
    }
    if (bookingResponse.data.status === 'CANCELLED') {
      this.setState({ error: 'This booking has been cancelled' });
      return;
    }
    this.handleUpdate(bookingResponse);
  }

  /**
   * Handle a booking update
   */
  async handleUpdate(response, vehicleType = this.state.vehicleType) {
    const updateState: any = {
      booking: response.data,
      isPaid: response.data.total_paid >= response.data.total_cost,
      isLoading: false,
      isReady: true,
    };
    if (!updateState.isPaid && response.data.payment_status !== 2) {
      this.setState({
        error: 'This booking has not been paid for via "To Pay On Account"',
      });
      return;
    }
    if (vehicleType === undefined) {
      updateState.vehicleType = find(this.props.vehicleTypes, {
        id: Number(response.data.vehicle_type_id),
      });
    }

    this.setState(updateState);
  }

  render() {
    const { booking, vehicleType } = this.state;
    let daysAgo;
    let expired;
    if (booking !== undefined) {
      daysAgo = moment().businessDiff(moment(booking.pre_auth_expiry_date)) - 1;
      expired = daysAgo > EXPIRATIONS.PRE_AUTH;
    }
    return (
      <RouteWrapper
        title="Resolve Account"
        ready={this.state.isReady}
        error={this.state.error}
        loading={this.state.isLoading}
        breadcrumbs={[
          {
            link: '/payments/pending-account',
            text: 'Pending Accounts',
          },
          {
            link: `/payments/pending-account/${this.state.companyId}`,
            text: this.state.booking ? this.state.booking.company.name : 'N/A',
          },
          {
            link: `/payments/pending-account/${this.state.companyId}/${
              this.state.id
            }`,
            text: `Resolve Account`,
          },
        ]}
      >
        <HeadingSection
          title={`Resolve Account for ${(this.state.booking &&
            this.state.booking.company.name) ||
            'N/A'}`}
          controls={[
            <IconButton
              key="view-booking-button"
              icon="truck"
              className="is-default"
              link={`/bookings/${this.state.id}`}
            >
              View Booking
            </IconButton>,
            <IconButton
              key="back-button"
              icon="undo"
              className="is-default"
              handleClick={() => {
                this.props.dispatch(goBack());
              }}
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <div className="columns is-multiline">
            <div className="column is-12-desktop is-7-widescreen">
              {!this.state.isPaid ? (
                <>
                  <Box>
                    <BookingPrices
                      booking={booking}
                      vehicleType={vehicleType}
                    />
                  </Box>
                  <BookingPayment
                    isAccountResolution
                    booking={booking}
                    handleUpdate={() => {
                      this.props.dispatch(goBack());
                    }}
                  />
                </>
              ) : (
                <Notification type="success">
                  <Icon icon="check-circle" />
                  &nbsp; This booking's payment has been resolved
                </Notification>
              )}
            </div>
            <div className="column is-12-desktop is-5-widescreen">
              <BookingSidebar booking={booking} />
            </div>
          </div>
        </Section>
      </RouteWrapper>
    );
  }
}
const mapStateToProps = ({ vehicleTypes }) => ({
  vehicleTypes: vehicleTypes.vehicleTypes,
});

export default connect(mapStateToProps)(Route);
